// Application configuration
export const APP_CONFIG = {
    name: 'Grupo Médico Empresarial',
    shortName: 'GME',
    tagline: 'Tu salud visual y dental en manos expertas',
    description: 'Servicios profesionales de óptica y odontología en Toluca con tecnología de vanguardia.',
    site: {
        url: 'https://gme.easytopweb.com',
        recommendedSubdomain: 'gme',
        alternativeSubdomain: 'grupo-medico',
        visitCounterEndpoint: '/api/visits',
    },

    // Contact information
    contact: {
        address: 'Júpiter 125, Colonia Meteoro, Toluca, México CP 50070',
        phone: '+52 722 631 8844',
        whatsapp: '5217226318844',
        email: 'contacto@grupomedicoempresarial.com',
        googleMaps: 'https://maps.app.goo.gl/mAtc3eHFuKVtUTkm9',
        hours: {
            weekdays: 'Lun - Vie: 9:00 AM - 7:00 PM',
            saturday: 'Sáb: 9:00 AM - 3:00 PM',
            sunday: 'Dom: Cerrado'
        },
        coordinates: {
            lat: 19.2906,
            lng: -99.6553
        }
    },

    // Social media
    social: {
        facebook: 'https://www.facebook.com/grupomedicoempresarial/',
        whatsapp: 'https://wa.me/5217226318844',
        instagram: '', // Add when available
        twitter: '', // Add when available
    },

    // Services configuration
    services: {
        optica: {
            title: 'Servicios de Óptica',
            icon: 'eye',
            color: '#0066cc',
            services: [
                {
                    id: 'examen-visual',
                    title: 'Exámenes Visuales Completos',
                    description: 'Evaluación integral de tu salud visual con técnicas tradicionales de muchos años de experiencia, probadas y efectivas.',
                    icon: 'search',
                    features: [
                        'Evaluación paciente a paciente',
                        'Análisis de agudeza visual',
                    ]
                },
                {
                    id: 'lentes-monturas',
                    title: 'Lentes y Monturas',
                    description: 'Amplia selección de marcas reconocidas y diseños exclusivos para todos los gustos.',
                    icon: 'glasses',
                    features: [
                        'Marcas premium Mexicanas',
                        'Lentes con filtro de luz azul',
                        'Lentes progresivos de alta gama',
                        'Garantía'
                    ]
                },
                {
                    id: 'lentes-contacto',
                    title: 'Lentes de Contacto',
                    description: 'Adaptación personalizada y seguimiento profesional para tu comodidad.',
                    icon: 'eye-dropper',
                    features: [
                        'Lentes diarios, semanales y mensuales',
                        'Lentes tóricos para astigmatismo',
                        'Lentes multifocales',
                        'Capacitación en uso y cuidado'
                    ]
                },
                {
                    id: 'lentes-sol',
                    title: 'Lentes de Sol',
                    description: 'Protección UV y estilo en una amplia gama de diseños y marcas premium.',
                    icon: 'sun',
                    features: [
                        'Protección UV 400',
                        'Lentes polarizados',
                        'Gradientes de moda',
                        'Diseños deportivos y casuales'
                    ]
                }
            ]
        },
        dental: {
            title: 'Servicios Dentales Especializados',
            icon: 'tooth',
            color: '#1a73e8',
            services: [
                {
                    id: 'consulta-general',
                    title: 'Consulta General',
                    description: 'Revisiones completas y diagnósticos precisos para mantener tu salud bucal.',
                    icon: 'stethoscope',
                    features: [
                        'Diagnóstico integral',
                        'Radiografías digitales',
                        'Plan de tratamiento personalizado',
                        'Historias clínicas digitales'
                    ]
                },
                {
                    id: 'odontologia-restaurativa',
                    title: 'Odontología Restaurativa',
                    description: 'Restauraciones, coronas y tratamientos para devolver funcionalidad a tus dientes.',
                    icon: 'tools',
                    features: [
                        'Resinas estéticas',
                        'Coronas de porcelana',
                        'Incrustaciones cerámicas',
                        'Endodoncia especializada'
                    ]
                },
                {
                    id: 'estetica-dental',
                    title: 'Estética Dental',
                    description: 'Blanqueamientos, carillas y tratamientos para perfeccionar tu sonrisa.',
                    icon: 'smile',
                    features: [
                        'Blanqueamiento profesional',
                        'Carillas de porcelana',
                        'Diseño de sonrisa digital',
                        'Armonización orofacial'
                    ]
                },
                {
                    id: 'prevencion',
                    title: 'Prevención',
                    description: 'Limpiezas, selladores y tratamientos preventivos para cuidar tu salud bucal.',
                    icon: 'shield-alt',
                    features: [
                        'Profilaxis dental',
                        'Aplicación de flúor',
                        'Selladores de fosetas',
                        'Educación en higiene oral'
                    ]
                },
                {
                    id: 'especialidades-dentales',
                    title: 'Especialidades Dentales',
                    description: 'Contamos con especialistas certificados en ortodoncia, endodoncia y periodoncia para brindarte tratamientos de alta especialidad.',
                    icon: 'user-md',
                    features: [
                        'Ortodoncia - Corrección de malposiciones',
                        'Endodoncia - Tratamientos de conducto',
                        'Periodoncia - Salud gingival',
                        'Certificaciones profesionales'
                    ]
                }
            ]
        }
    },

    // 3D Models and assets
    assets: {
        models: {
            lensRefraction: '/models/lens-refraction.glb',
            dentalEquipment: '/models/dental-equipment.glb',
            opticalEquipment: '/models/optical-equipment.glb',
            eyeAnatomy: '/models/eye-anatomy.glb',
            toothAnatomy: '/models/tooth-anatomy.glb'
        },
        textures: {
            medicalPattern: '/textures/medical-pattern.jpg',
            glassReflection: '/textures/glass-reflection.jpg',
            dentalXray: '/textures/dental-xray.jpg'
        },
        animations: {
            heroLottie: '/animations/hero-medical.json',
            successAnimation: '/animations/success.json',
            loadingAnimation: '/animations/loading.json'
        }
    },

    // Animation settings
    animation: {
        duration: {
            fast: 0.3,
            normal: 0.6,
            slow: 1.0
        },
        easing: {
            easeInOut: [0.4, 0, 0.2, 1],
            easeOut: [0, 0, 0.2, 1],
            easeIn: [0.4, 0, 1, 1],
            bounce: [0.68, -0.55, 0.265, 1.55]
        },
        stagger: 0.1
    },

    // Performance settings
    performance: {
        lazyLoadOffset: 100,
        debounceDelay: 300,
        throttleLimit: 100,
        preloadImages: true,
        enableServiceWorker: true
    },

    // SEO and Meta
    seo: {
        keywords: [
            'óptica toluca',
            'consultorio dental toluca',
            'examen visual',
            'lentes toluca',
            'odontología toluca',
            'grupo médico empresarial',
            'salud visual',
            'salud dental',
            'meteoro toluca'
        ],
        openGraph: {
            type: 'website',
            siteName: 'Grupo Médico Empresarial',
            images: [
                {
                    url: '/og-image.jpg',
                    width: 1200,
                    height: 630,
                    alt: 'Grupo Médico Empresarial - Óptica y Consultorio Dental'
                }
            ]
        },
        twitter: {
            card: 'summary_large_image',
            site: '@grupomedicoempresarial', // Add when available
        }
    },

    // Theme colors
    theme: {
        primary: '#0066cc',
        accent: '#1a73e8',
        success: '#10b981',
        warning: '#f59e0b',
        error: '#ef4444',
        neutral: '#6b7280'
    },

    // Feature flags
    features: {
        enable3D: true,
        enableAnimations: true,
        enableAnalytics: false as boolean, // Enable in production
        enableChatbot: false, // Future feature
        enableOnlineBooking: false, // Future feature
        enableVirtualTryOn: false, // Future feature
        enablePWA: true
    }
}

// Type-safe access to configuration
export type AppConfig = typeof APP_CONFIG

// Environment-specific overrides
export const getConfig = () => {
    if (import.meta.env.PROD) {
        return {
            ...APP_CONFIG,
            features: {
                ...APP_CONFIG.features,
                enableAnalytics: true
            }
        }
    }

    return APP_CONFIG
}